<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>服務機關：</td>
                  <td>
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                       :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      1 <= loginInfo.layerNum
                    "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                       :disabled="
                      (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      2 <= loginInfo.layerNum) && (loginInfo.govCode != '355010000I' && loginInfo.govCode != 'A11100000F' )
                    "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                       :disabled="
                      (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      3 <= loginInfo.layerNum) && (loginInfo.govCode != '355010000I' && loginInfo.govCode != 'A11100000F' )
                    "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                       :disabled="
                      (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      4 <= loginInfo.layerNum) && (loginInfo.govCode != '355010000I' && loginInfo.govCode != 'A11100000F' )
                    "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <a
                      href="/PdpsCli/download/A103 申報人資料整批移轉 操作說明.pdf"
                      target="_blank"
                      style="margin-left: 10px"
                    >
                      下載操作說明
                    </a>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關：</td>
                  <td>
                    <select
                      v-model="form.govCode1"
                      style="min-width: 200px"
                      @change="GovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode2"
                      style="min-width: 200px"
                      @change="GovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode3"
                      style="min-width: 200px"
                      @change="GovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.govCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>身分證統一編號：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.idn" />
                  </td>
                </tr>
                <tr>
                  <td>姓名：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td>在職狀態：</td>
                  <td>
                    <select v-model="form.jobstatus" style="min-width: 480px">
                      <option
                        v-for="(item, index) in dropDownList.onJobs"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td style="text-align: left; color: red">
                    功能說明：<br />
                    本功能可將申報人基本資料與其申報資料，自「原機關」移至「新機關」，執行本功能後，原機關即無申報人資料。
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <input
                      type="submit"
                      class="btn"
                      value="查詢"
                      @click="
                        () => {
                          this.form.currentpage = 1;
                          this.form.pagesize = 10;
                          this.doQuery();
                        }
                      "
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="btnClear()"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%" v-if="grid.gridDatas">
            <tbody>
              <tr>
                <td>
                  <button class="btn" @click="btnAllCheck()">全選</button>
                  <button class="btn" @click="btnCancelCheck()">取消</button>
                  <button class="btn" @click="btnTtansOnJob()">整批移轉</button>
                </td>
                <td v-if="grid && grid.paginaiton" align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th style="min-width: 100px">選取</th>
                    <th style="min-width: 80px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('NAME', Sort);
                          }
                        "
                      >
                        姓名</u
                      >
                    </th>
                    <th style="width: 80px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('IDN', Sort);
                          }
                        "
                        >身分證統一編號</u
                      >
                    </th>
                    <th style="min-width: 100px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('JOB_GOV_CODE', Sort);
                          }
                        "
                        >服務機關</u
                      >
                    </th>
                    <th style="min-width: 100px">受理申報機關</th>
                    <th style="min-width: 70px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('title', Sort);
                          }
                        "
                        >單位及職稱</u
                      >
                    </th>
                    <th style="min-width: 70px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('tel', Sort);
                          }
                        "
                        >聯絡電話</u
                      >
                    </th>
                    <th style="min-width: 70px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('arrivE_DATE', Sort);
                          }
                        "
                        >到職日</u
                      >
                    </th>
                    <th style="min-width: 70px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('leave', Sort);
                          }
                        "
                        >現職狀況</u
                      >
                    </th>
                    <th style="min-width: 70px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('leavE_REASON', Sort);
                          }
                        "
                        >備註</u
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="checkbox"
                        v-model="form.Selected"
                        :value="{ idn: data.idn, gov_code: data.goV_CODE, job_gov_code: data.joB_GOV_CODE }"
                      />
                    </td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.idn }}</td>
                    <td>{{ data.joB_GOV_NAME }}</td>
                    <td style="white-space: normal;">
                      {{ data.goV_NAME }}
                      <a
                        v-show="data.goV_CODE_LOG_FLAG == 'Y'"
                        style="color: red; display: block; cursor: pointer"
                        @click="btnSearchLog(data.idn)"
                        >(變動紀錄)</a
                      >
                    </td>
                    <td>{{ data.title }}</td>
                    <td>{{ data.tel }}</td>
                    <td>{{ data.arrivE_DATE_STR }}</td>
                    <td>{{ data.leave }}</td>
                    <td>{{ data.leavE_REASON }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <Modal
      v-model="modal.show"
      :title="modal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr v-if="false">
                <td>去職日</td>
                <td>
                  <DatePicker
                    v-model="modal.form.leavE_DATE"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
              </tr>
              <tr v-if="false">
                <td>在職狀態</td>
                <td>
                  <select v-model="modal.form.status" style="min-width: 480px">
                    <option
                      v-for="(item, index) in modal.dropDownList.onJobs"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>備註</td>
                <td>
                  <input
                    type="text"
                    size="80"
                    maxlength="80"
                    v-model="modal.form.remark"
                  />
                </td>
              </tr>
              <tr>
                <td>新服務機關</td>
                <td>
                  <select
                    v-model="modal.form.jobGovCode1"
                    style="min-width: 200px"
                  >
                    <option
                      v-for="(item, index) in modal.dropDownList.jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="modal.form.jobGovCode2"
                    style="min-width: 200px"
                  >
                    <option
                      v-for="(item, index) in modal.dropDownList.jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="modal.form.jobGovCode3"
                    style="min-width: 200px"
                  >
                    <option
                      v-for="(item, index) in modal.dropDownList.jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="modal.form.jobGovCode4"
                    style="min-width: 200px"
                  >
                    <option
                      v-for="(item, index) in modal.dropDownList.jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>新受理申報機關</td>
                <td>
                  <select
                    v-model="modal.form.govCode1"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in modal.dropDownList.govCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="modal.form.govCode2"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in modal.dropDownList.govCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="modal.form.govCode3"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in modal.dropDownList.govCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="modal.form.govCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in modal.dropDownList.govCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>

              <tr>
                <td>新受理機關政風人員帳號</td>
                <td><input type="text" v-model="modal.form.neW_ID" /></td>
              </tr>
              <tr>
                <td>新受理機關政風人員密碼</td>
                <td>
                  <p>
                    <input
                      type="text"
                      style="
                        font-family: text-security-disc;
                        -webkit-text-security: disc;
                      "
                      v-model="modal.form.neW_PW"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="確定"
                        @click="btnModalOK()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnModalClear()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </Modal>

    <LogModal
      v-model="LogModal.show"
      :title="LogModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information" v-if="LogModal.grid">
        <table width="100%">
          <tbody>
            <tr>
              <td v-if="LogModal.grid.paginaiton" align="right">
                <input
                  type="button"
                  value="<<"
                  class="btn"
                  style="height: 28px"
                  @click="
                    LogModal.form.currentpage =
                      LogModal.grid.paginaiton.pageNo - 1
                  "
                  v-show="LogModal.grid.paginaiton.pageNo > 1"
                />
                <span
                  v-for="(data, index) in LogModal.grid.paginaiton.pages"
                  :key="index"
                  style="cursor: pointer"
                  :style="
                    LogModal.grid.paginaiton.pageNo == data
                      ? 'color:red'
                      : 'color:black'
                  "
                  @click="LogModal.form.currentpage = parseInt(data)"
                >
                  {{
                    LogModal.grid.paginaiton.pageNo == data
                      ? "[" + data + "]"
                      : data
                  }}
                </span>
                <input
                  type="button"
                  class="btn"
                  value=">>"
                  style="height: 28px"
                  v-show="
                    LogModal.grid.paginaiton.pageNo <
                    LogModal.grid.paginaiton.totalPage
                  "
                  @click="
                    LogModal.form.currentpage =
                      LogModal.grid.paginaiton.pageNo + 1
                  "
                />
                ［每頁<input
                  type="text"
                  v-model.number.lazy="LogModal.form.pagesize"
                  size="2"
                  maxlength="4"
                />

                <input type="button" class="btn" value="筆" />，第<input
                  type="text"
                  v-model.number.lazy="LogModal.form.currentpage"
                  size="2"
                  maxlength="4"
                />
                <input type="button" class="btn" value="頁" />，共
                {{ LogModal.grid.paginaiton.totalPage }} 頁
                {{ LogModal.grid.paginaiton.totalCount }} 筆］
              </td>
            </tr>
          </tbody>
        </table>
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>變動時間</th>
                  <th>原受理申報機關</th>
                  <th>新受理申報機關</th>
                  <th>類別</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in LogModal.grid.gridLogDatas"
                  :key="index"
                >
                  <td>{{ data.changE_TIME_STR }}</td>
                  <td>{{ data.olD_GOV_CODE_NAME }}</td>
                  <td>{{ data.neW_GOV_CODE_NAME }}</td>
                  <td>{{ data.kind }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </LogModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenu,logOut } from "@/config/util.js";
import {
  SearchGovCode,
  SearchRGovCode,
  SearchGridOnJob,
  A103_SearchGrid,
  A103_ReSearchGrid,
  A101_SearchLog,
  A103_Trans,
} from "@/service/api.js";

export default {
  name: "A103",
  data: function () {
    return {
      pageData: {
        MenuIndex: 1,
        MenuName: "",
        PrgName: "A103",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      Order: "",
      Sort: "",
      form: {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "1",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        jobstatus: "",
        currentpage: 1,
        pagesize: 10,
        Selected: [],
      },
      dropDownList: {
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
        //在職狀態
        onJobs: [],
      },
      grid: {},
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      modal: {
        show: false,
        title: "",
        grid: [],
        form: {
          leavE_DATE: "",
          status: "",
          remark: "",
          govCode1: "",
          govCode2: "",
          govCode3: "",
          govCode4: "",
          jobGovCode1: "",
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          neW_ID: "",
          neW_PW: "",
        },
        dropDownList: {
          govCode1s: [],
          govCode2s: [],
          govCode3s: [],
          govCode4s: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
          //在職狀態
          onJobs: [],
        },
        PreData: {},
      },
      LogModal: {
        show: false,
        title: "A103申報人資料變動紀錄-查詢",
        form: {
          idn: "",
          pagesize: 10,
          currentpage: 1,
        },
        grid: {},
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
    Modal: VueModal,
    LogModal: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    //取得服務機關第一層類別
    getSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得服務機關第二層類別
    getSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得服務機關第三層類別
    getSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得服務機關第四層類別
    getSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
         if(self.loginInfo.govCode == '355010000I')
        {
          self.dropDownList.jobGovCode2s = rData.returnObject.filter(x=>x.value == '355010000I' || x.value == '355020000I');
        }
        else if(self.loginInfo.govCode == 'A11100000F')
        {
          self.dropDownList.jobGovCode2s = rData.returnObject.filter(x=>x.value == 'A11100000F' || x.value == 'A11000600F');
        }
        else
        {
          self.dropDownList.jobGovCode2s = rData.returnObject;
        }
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //取得在職狀態
    getOnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.dropDownList.onJobs = rData.returnObject;
      });
    },
    //查詢
    doQuery: function () {
      const self = this;
       //清空
      self.Order = "";
      self.Sort = "";
      self.form.Selected = [];
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        LEAVE: self.form.jobstatus,
        GOV: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        GOVCHECK: parseInt(self.form.govCheck),
        JOBGOV: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        JOBGOVCHECK: parseInt(self.form.jobGovCheck),
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      A103_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "IDN";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      self.form.Selected = [];
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        LEAVE: self.form.jobstatus,
        GOV: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        GOVCHECK: parseInt(self.form.govCheck),
        JOBGOV: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        JOBGOVCHECK: parseInt(self.form.jobGovCheck),
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      A103_ReSearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },

    GovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.govCode1 = self.SessionGovCode;
        form.govCode2 = "";
        form.govCode3 = "";
        form.govCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.govCode1 = govCodeArray[0];
          form.govCode2 = govCodeArray[1];
          form.govCode3 = govCodeArray[2];
          form.govCode4 = govCodeArray[3];
        }
      }
    },
    GovCode1Change: function () {
      const self = this;
      self.form.govCode2 = "";
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode2s = [];
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode2Change: function () {
      const self = this;
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode3Change: function () {
      const self = this;
      self.form.govCode4 = "";
      self.dropDownList.govCode4s = [];
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    //全選
    btnAllCheck: function () {
      const self = this;
      self.btnCancelCheck();
      if (!self.form.Selected.length) {
        self.grid.gridDatas.forEach((g) =>
          self.form.Selected.push({ idn: g.idn, gov_code: g.goV_CODE, job_gov_code: g.joB_GOV_CODE})
        );
      }
    },
    //取消
    btnCancelCheck: function () {
      const self = this;
      self.form.Selected = [];
    },
    //重填
    btnClear: function () {
      const self = this;
      this.form = {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "1",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        jobstatus: "",
        currentpage: 1,
        pagesize: 10,
        Selected: [],
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
      self.GovCodeInit(self.form);
      self.getSearchGovCode1();
    },
    //modal
    //取得新服務機關第一層類別
    modalGetSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.modal.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得新服務機關第二層類別
    modalGetSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.modal.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得新服務機關第三層類別
    modalGetSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.modal.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得新服務機關第四層類別
    modalGetSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.modal.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得新受理申報機關第一層類別
    modalGetSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.modal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得新受理申報機關第二層類別
    modalGetSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.modal.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得新受理申報機關第三層類別
    modalGetSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.modal.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得新受理申報機關第四層類別
    modalGetSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.modal.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //取得新在職狀態
    modalGetOnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.modal.dropDownList.onJobs = rData.returnObject;
      });
    },
    //第一頁整批移轉按紐
    btnTtansOnJob: function () {
      const self = this;
      if (self.form.Selected.length) {
        self.modal.show = true;
        self.modal.title = self.pageData.MenuName + "-整批機關變動";
        self.btnModalClear();
        self.modalGetOnJob();
        self.GovCodeInit(self.modal.form);
        self.modalGetSearchGovCode1();
        self.JobGovCodeInit(self.modal.form);
        self.modalGetSearchJobGovCode1();
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先勾選移轉名單!"];
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      }
    },
    //第一頁服務機關變動紀錄
    btnSearchLog: function (idn) {
      const self = this;
      if (
        !self.checkPage(
          self.LogModal.form.currentpage,
          self.LogModal.form.pagesize
        )
      )
        return;
      self.LogModal.form.idn = idn;
      let postData = {
        idn: self.LogModal.form.idn,
        currentpage: self.LogModal.form.currentpage,
        pagesize: self.LogModal.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "變動紀錄",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      A101_SearchLog(postData).then((rData) => {
        if(rData.result){
          self.LogModal.grid = rData.returnObject;
          self.LogModal.show = true;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //第二頁確定
    btnModalOK: function () {
      const self = this;
      let errorMsg = [];
      let ebool = false;
      // if (self.modal.form.leavE_DATE == "") {
      //   errorMsg.push("請填寫去職日");
      // }
      if (self.modal.form.govCode1 == "") {
        errorMsg.push("請填寫新受理機關");
      }
      if (self.modal.form.jobGovCode1 == "") {
        errorMsg.push("請填寫新服務機關");
      }
      self.form.Selected.forEach((element) => {
        if (ebool) {
          //不動作
        } else {
          var newGovCode = "";
          if (self.modal.form.govCode4) {
            newGovCode = self.modal.form.govCode4;
          }
          else if (self.modal.form.govCode3) {
            newGovCode = self.modal.form.govCode3;
          }
          else if (self.modal.form.govCode2) {
            newGovCode = self.modal.form.govCode2;
          }
          else if (self.modal.form.govCode1) {
            newGovCode = self.modal.form.govCode1;
          }
          if (element.gov_code == newGovCode || ebool) {
          errorMsg.push("新受理機關不可與舊受理機關相同");
          ebool = true;
        }
        }
      });

      // if (self.modal.form.status == "") {
      //   errorMsg.push("請填寫在職狀態");
      // }
      if (self.modal.form.neW_ID.trim() == "") {
        errorMsg.push("請填寫新受理機關政風人員帳號");
      }
      if (self.modal.form.neW_PW == "") {
        errorMsg.push("請填寫新受理機關政風人員密碼");
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }
      if (self.form.Selected.length) {
        let postData = {
          transDatas: self.form.Selected,
          leavE_DATE: self.modal.form.leavE_DATE,
          status: self.modal.form.status,
          remark: self.modal.form.remark,
          neW_GOV_CODE: self.modal.form.govCode4
            ? self.modal.form.govCode4
            : self.modal.form.govCode3
            ? self.modal.form.govCode3
            : self.modal.form.govCode2
            ? self.modal.form.govCode2
            : self.modal.form.govCode1
            ? self.modal.form.govCode1
            : "",
          neW_GOV_CODE_STR:
            self.modal.form.govCode1 +
            "," +
            self.modal.form.govCode2 +
            "," +
            self.modal.form.govCode3 +
            "," +
            self.modal.form.govCode4,
          neW_JOB_GOV_CODE: self.modal.form.jobGovCode4
            ? self.modal.form.jobGovCode4
            : self.modal.form.jobGovCode3
            ? self.modal.form.jobGovCode3
            : self.modal.form.jobGovCode2
            ? self.modal.form.jobGovCode2
            : self.modal.form.jobGovCode1
            ? self.modal.form.jobGovCode1
            : "",
          neW_JOB_GOV_CODE_STR:
            self.modal.form.jobGovCode1 +
            "," +
            self.modal.form.jobGovCode2 +
            "," +
            self.modal.form.jobGovCode3 +
            "," +
            self.modal.form.jobGovCode4,
          neW_ID: self.modal.form.neW_ID,
          neW_PW: self.modal.form.neW_PW,
          userid: self.loginInfo.id,
          useridn: self.loginInfo.idn,
          goV_CODE: self.loginInfo.govCode,
          goV_CODE_STR: self.loginInfo.govCodeStr,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "整批移轉",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        Object.keys(postData).map(
          (k) =>
            (postData[k] =
              typeof postData[k] == "string" ? postData[k].trim() : postData[k])
        );
        A103_Trans(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["整批移轉成功"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.modal.show = false;
              self.form.Selected = [];
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            //self.Alert.txt = "整批移轉錯誤";
            self.Alert.txt = [rData.messages[0]];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先勾選移轉名單!"];
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      }
    },
    //第二頁重填
    btnModalClear: function () {
      const self = this;

      self.modal.form.leavE_DATE = "";
      self.modal.form.status = "";
      self.modal.form.remark = "";
      self.modal.form.neW_ID = "";
      self.modal.form.neW_PW = "";

      self.GovCodeInit(self.modal.form);
      self.modalGetSearchGovCode1();
      self.JobGovCodeInit(self.modal.form);
      self.modalGetSearchJobGovCode1();
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    GetSearchRGovCode: function (newValue) {
      const self = this;
      let GovCode = { GOV_CODE: newValue };
      SearchRGovCode(GovCode).then((rData) => {
        if (rData.returnObject.length > 0) {
          self.modal.form.govCode1 =
            rData.returnObject[0].rGovCodeStr.split(",")[0];
          self.modal.form.govCode2 =
            rData.returnObject[0].rGovCodeStr.split(",")[1];
          self.modal.form.govCode3 =
            rData.returnObject[0].rGovCodeStr.split(",")[2];
          self.modal.form.govCode4 =
            rData.returnObject[0].rGovCodeStr.split(",")[3];
        } else if (newValue != "") {
          self.modal.form.govCode1 = "";
          self.modal.form.govCode2 = "";
          self.modal.form.govCode3 = "";
          self.modal.form.govCode4 = "";

          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["此服務機關未有受理申報機構，請洽政風人員確認"];
          //self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.GovCodeInit(self.form);
    self.JobGovCodeInit(self.form);
    self.getSearchGovCode1();
    self.getSearchJobGovCode1();
    self.getOnJob();
    self.doQuery();
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode2(newValue);
    },
    "form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode3(newValue);
    },
    "form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "modal.form.govCode1": function (newValue, oldValue) {
      const self = this;
      // self.modal.form.jobGovCode1 = newValue;
      // if (newValue === "") {
      //   self.modal.form.govCode2 = "";
      //   self.modal.form.govCode3 = "";
      //   self.modal.form.govCode4 = "";
      //   self.modal.dropDownList.govCode2s = [];
      //   self.modal.dropDownList.govCode3s = [];
      //   self.modal.dropDownList.govCode4s = [];
      // } else {
      //   if (newValue != oldValue) {
      //     self.modal.form.govCode2 = "";
      //     self.modal.form.govCode3 = "";
      //     self.modal.form.govCode4 = "";
      //     self.modal.dropDownList.govCode2s = [];
      //     self.modal.dropDownList.govCode3s = [];
      //     self.modal.dropDownList.govCode4s = [];
      //   }
      if (newValue != "") self.modalGetSearchGovCode2(newValue);
      // }
    },
    "modal.form.govCode2": function (newValue, oldValue) {
      const self = this;
      // self.modal.form.jobGovCode2 = newValue;
      // if (newValue === "") {
      //   self.modal.form.govCode3 = "";
      //   self.modal.form.govCode4 = "";
      //   self.modal.dropDownList.govCode3s = [];
      //   self.modal.dropDownList.govCode4s = [];
      // } else {
      //   if (newValue != oldValue) {
      //     self.modal.form.govCode3 = "";
      //     self.modal.form.govCode4 = "";
      //     self.modal.dropDownList.govCode3s = [];
      //     self.modal.dropDownList.govCode4s = [];
      //   }
      if (newValue != "") self.modalGetSearchGovCode3(newValue);
      // }
    },
    "modal.form.govCode3": function (newValue, oldValue) {
      const self = this;
      // self.modal.form.jobGovCode3 = newValue;
      // if (newValue === "") {
      //   self.modal.form.govCode4 = "";
      //   self.modal.dropDownList.govCode4s = [];
      // } else {
      if (newValue != "") self.modalGetSearchGovCode4(newValue);
      // }
    },
    "modal.form.govCode4": function (newValue, oldValue) {
      const self = this;
      // self.modal.form.jobGovCode4 = newValue;
    },
    "modal.form.jobGovCode1": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.modal.form.jobGovCode2 = "";
        self.modal.form.jobGovCode3 = "";
        self.modal.form.jobGovCode4 = "";
        self.modal.dropDownList.jobGovCode2s = [];
        self.modal.dropDownList.jobGovCode3s = [];
        self.modal.dropDownList.jobGovCode4s = [];
      }
      self.modalGetSearchJobGovCode2(newValue);
      self.modal.form.govCode1 = newValue;
      self.GetSearchRGovCode(newValue);
    },
    "modal.form.jobGovCode2": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.modal.form.jobGovCode3 = "";
        self.modal.form.jobGovCode4 = "";
        self.modal.dropDownList.jobGovCode3s = [];
        self.modal.dropDownList.jobGovCode4s = [];
      } else {
        if (newValue != oldValue) {
          self.modal.form.jobGovCode3 = "";
          self.modal.form.jobGovCode4 = "";
          self.modal.dropDownList.jobGovCode3s = [];
          self.modal.dropDownList.jobGovCode4s = [];
        }
        self.modalGetSearchJobGovCode3(newValue);
      }
      self.modal.form.govCode2 = newValue;
      self.GetSearchRGovCode(newValue);
    },
    "modal.form.jobGovCode3": function (newValue, oldValue) {
      const self = this;

      if (newValue === "") {
        self.modal.form.jobGovCode4 = "";
        self.modal.dropDownList.jobGovCode4s = [];
      } else {
        self.modalGetSearchJobGovCode4(newValue);
      }
      self.modal.form.govCode3 = newValue;
      self.GetSearchRGovCode(newValue);
    },
    "modal.form.jobGovCode4": function (newValue, oldValue) {
      const self = this;
      self.modal.form.govCode4 = newValue;
      self.GetSearchRGovCode(newValue);
    },
    "LogModal.form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.btnSearchLog(this.LogModal.form.idn);
      }
    },
    "LogModal.form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.btnSearchLog(this.LogModal.form.idn);
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
